var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    !_vm.inviteStatus.isUserLoggedIn
      ? _c("div", { staticClass: "text-center" }, [
          _c("h1", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "JOIN_INVITE_SUCCESS",
                expression: "'JOIN_INVITE_SUCCESS'"
              }
            ],
            staticClass: "title md-title"
          }),
          _vm._v(" "),
          _c("p", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "JOIN_INVITE_SUCCESS_SUBHEADER",
                expression: "'JOIN_INVITE_SUCCESS_SUBHEADER'"
              }
            ],
            staticClass: "subtitle"
          }),
          _vm._v(" "),
          _c("a", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "BACK_LOGIN_LINK",
                expression: "'BACK_LOGIN_LINK'"
              }
            ],
            staticClass: "button button--transparent-grad pulse m-t-20",
            attrs: { href: "#" },
            on: { click: _vm.goToLogin }
          })
        ])
      : _vm._e(),
    _vm._v(" "),
    _vm.inviteStatus.isUserLoggedIn
      ? _c("div", { staticClass: "text-center" }, [
          _c("h1", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "JOIN_INVITE_SUCCESS",
                expression: "'JOIN_INVITE_SUCCESS'"
              }
            ],
            staticClass: "title md-title"
          }),
          _vm._v(" "),
          _c("p", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "JOIN_INVITE_SUCCESS_LOGGED_SUBHEADER",
                expression: "'JOIN_INVITE_SUCCESS_LOGGED_SUBHEADER'"
              }
            ],
            staticClass: "subtitle"
          }),
          _vm._v(" "),
          _c("a", {
            directives: [
              {
                name: "t",
                rawName: "v-t",
                value: "BACK_DASHBOARD_LINK",
                expression: "'BACK_DASHBOARD_LINK'"
              }
            ],
            staticClass: "button button--transparent-grad pulse m-t-20",
            attrs: { href: "#" },
            on: { click: _vm.goToDashboard }
          })
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }